import { openResultHistory, openTransactionHistory } from "@/modules/commonPopupResultHistory";
import { toggleHowToPlay } from "@/modules/howToPlay";
import { assetImg } from "@/modules/moduleImporter";
import moneyFormat from "@/modules/moneyFormat";
import { updateVideoQuality } from "@/modules/videoQuality";
import { IUserdataType } from "@/types/GlobalTypes";
import React from "react";
import MobileLobby from ".";
import SettingsForm from "../Settings";

// Todo: refactor this
function userInfoFragment(userdata: IUserdataType) {
	if (!userdata)
		return null;

	const { nickname, balance, lang, currency } = userdata.user;

	return (
		<div className="sidebar-user-info">
			<div className="sidebar-username">
				<span>{nickname}</span>
			</div>

			<div className="sidebar-user-balance">
				<span>
					{moneyFormat(balance, lang, currency)}
				</span>
			</div>

			<br />
		</div>
	)
}

function separator() {
	return <div className="sidebar-decoration" />;
}

export function sidebarFragment(this: MobileLobby) {
	const
		{ showSidebar, orientation, userdata } = this.state;

	return (
		<>
			<div id="overlay"
				className={showSidebar ? "" : "hide"}
				onClick={this.closeSidebar.bind(this)} />

			<div className={"sidebar-left " + orientation} id="sidebar-wrapper">
				<ul className="nav sidebar-nav">
					<br />

					{assetImg("sidemenu", "user.svg", "", "user-info user-icon")}

					{userInfoFragment(userdata)}

					<br />

					{separator()}

					<br />

					{
						this.state.uniqueGamePcodes &&
						<li>
							<div className="link"
								{...{ game: this.state.uniqueGamePcodes[this.state.uniqueGamePcodes.length - 1] }}
								onClick={toggleHowToPlay.bind(this)}>

								{assetImg("sidemenu", "how_to_play.svg", "", "lobby-sidebar-icon")}

								<div>
									{this.state.lang["txt_how_to_play"].toLowerCase()}
								</div>
							</div>
						</li>
					}

					<li>
						<div className="link" onClick={openResultHistory.bind(this)}>
							{assetImg("sidemenu", "result_history.svg", "", "lobby-sidebar-icon")}

							<div>
								{this.state.lang["txt_result_history"].toLowerCase()}
							</div>
						</div>
					</li>

					<li>
						<div className="link" onClick={openTransactionHistory.bind(this)}>
							{assetImg("sidemenu", "transaction_history.svg", "", "lobby-sidebar-icon")}

							<div>
								{this.state.lang["txt_transaction_history"].toLowerCase()}
							</div>
						</div>
					</li>

					<li>
						<div className="link" style={{ opacity: 0.5 }} {...{ disabled: true }}>

							{assetImg("sidemenu", "news.svg", "", "lobby-sidebar-icon")}

							<div>
								{this.state.lang["txt_news"].toLowerCase()}
							</div>
						</div>
					</li>

					<br />
					<br />

					{separator()}

					<br />

					<SettingsForm
						langdata={this.state.lang}

						{...this.state}

						updateSettings={this.updateSettings.bind(this)}

						langStr={this.state.userdata.user.lang}
						updateLanguage={this.updateLanguage.bind(this)}

						videoQuality={this.state.activeVideoQuality}
						updateVideoQuality={updateVideoQuality.bind(this)}
					/>

					<br />

					{separator()}
				</ul>
			</div>
		</>
	);
}
